export default function LessonUI({
  pages,
  currentPageIndex,
  onPrevPage,
  onNextPage,
  onStartQuiz,
  backTo,
  renderExtraSection,
}) {
  const totalPages = pages.length;
  const isLastPage = currentPageIndex === totalPages - 1;
  const page = pages[currentPageIndex];

  if (!page) return <div>NO PAGE AT INDEX {currentPageIndex}</div>;

  return (
    <div className="lesson-book-container" style={{ textAlign: "center" }}>
      <h2 className="lesson-page-title">{page.title}</h2>
      <div className="lesson-page-content">{page.content}</div>
      
      {/* >>> Add this: <<< */}
      {renderExtraSection && renderExtraSection({ page, currentPageIndex })}

      <div className="lesson-page-navigation" style={{ marginTop: 24 }}>
        {currentPageIndex > 0 && (
          <button className="lesson-nav-btn" onClick={onPrevPage}>
            ◀ Previous
          </button>
        )}
        {currentPageIndex < totalPages - 1 && (
          <button className="lesson-nav-btn" onClick={onNextPage} style={{ marginLeft: 12 }}>
            Next ▶
          </button>
        )}
        {isLastPage && (
          <button className="lesson-nav-btn" style={{ marginLeft: 24 }} onClick={onStartQuiz}>
            Start Quick Quiz
          </button>
        )}
      </div>
      <br />
    </div>
  );
}
